<template>
  <div class="default">
    <Head />
    <div class="default-content">
      <slot></slot>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/layout/Head'
import Foot from '@/components/layout/Foot'

export default {
  name: 'Default',
  components: { Foot, Head }
}
</script>

<style scoped lang="scss">
.default {
  width: 100%;
  min-width: 1200px;
  min-height: 100%;
  position: relative;
  background-color: #1f1f25;
  display: grid;
  grid-template-rows: auto 1fr auto;
}
</style>
